import React from 'react';

import styled from 'styled-components';
import PropTypes from 'prop-types';

const decidePadding = ({ size }) => {
	switch (size) {
		case 'xtraSmall':
			return '0px';
		case 'small':
			return '50px 0px;';
		default:
			return '80px 0px;';
	}
};

const decideSize = ({ size }) => {
	switch (size) {
		case 'xtraSmall':
			return '1.5em';
		case 'small':
			return '3em';
		default:
			return '6em';
	}
};

const decideColor = ({ size, theme }) => {
	switch (size) {
		case 'xtraSmall':
			return theme.colors.white;
		default:
			return theme.colors.primary;
	}
};

const RingDiv = styled.div`
	position: absolute;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-around;
`;

const InnerDiv = styled.div`
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: ${(props) => decideSize(props)};
  height: ${(props) => decideSize(props)};
  border: 0.2em solid ${(props) => decideColor(props)};
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: ${(props) =>
		decideColor(props)} transparent transparent transparent;
  &:nth-child(1) {
    animation-delay: -0.45s;
  }
  &:nth-child(2) {
    animation-delay: -0.3s;
  }
  &:nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
`;

const PageLoader = ({ size }) => (
	<RingDiv>
		<InnerDiv size={size} />
		<InnerDiv size={size} />
		<InnerDiv size={size} />
		<InnerDiv size={size} />
	</RingDiv>
);

const SmallLoaderContainer = styled.div`
	top: 1%;
	align-items: center;
	display: flex;
	flex-direction: row;
	justify-content: space-around;
`;

const PageLoaderContainer = styled.div`
	height: 100%;
	position: absolute;
	top: 0;
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-around;
	padding: ${(props) => decidePadding(props)};
`;

PageLoader.defaultProps = {
	size: '',
};

PageLoader.propTypes = {
	size: PropTypes.string,
};

export { PageLoader, PageLoaderContainer, SmallLoaderContainer };
